<script>
import {getQueryStringParam, appendQueryString} from '@/helpers/Utils'

export default {
    name: 'oc-tabs',
    props: {
        // url hash param
        name: {
            type: [String, Number],
            default: 'tabs'
        },
        headerAttrs: {
            type: Object,
            default: () => ({})
        },
        useRouter: {
            type: Boolean,
            default: true
        },
        animation: {
            type: [Boolean, String],
            default: false,
            validator: function (value) {
                return [false, 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out'].indexOf(value) !== -1
            }
        }
    },
    data() {
        return {
            tabs: []
        }
    },
    created() {
        this.tabs = this.$children
    },
    methods: {
        selectTab(selectedTab) {
            this.selectTabByID(selectedTab.id, true)
        },
        selectTabByID(tabID, useRouter = false) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.id === tabID)
            })

            if( this.useRouter && useRouter ) {
                appendQueryString.bind(this)({
                    [this.name]: tabID
                })
            }

            this.$emit('change', this.getActiveTab())
        },
        getActiveTab() {
            let activeTab = false

            this.tabs.forEach(tab => {
                if( tab.isActive ) {
                    activeTab = tab
                }
            })

            return activeTab
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                // detect and activate the tab from url
                setTimeout(() => {
                    if( this.useRouter ) {
                        let tabID = getQueryStringParam.bind(this)(this.name)

                        if( tabID !== undefined && this.getActiveTab().id !== tabID ) {
                            this.selectTabByID(tabID)
                        }
                    }
                }, 0)
            }
        }
    }
}
</script>
